module.exports = __webpack_public_path__ + "static/media/icon-manage.5e99d8ec.svg";